exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#sw-breadcrumbs .icon {\n  width: 10px;\n  height: 10px;\n  margin-right: 10px;\n}\n#sw-breadcrumbs a:hover {\n  color: #007053;\n  text-decoration: underline;\n}\n#sw-breadcrumbs a:hover path {\n  fill: #007053;\n}", ""]);
